import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xos-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BurgerMenuComponent {}
